'use client';
import styled, { css } from 'styled-components';

const stretchLinkAndButton = css`
  width: 100%;
  max-width: 100%;

  & a {
    display: block;
    width: 100%;
  }

  & button {
    width: 100%;
  }
`;

export const StyledCtaButton = styled.div`
  display: flex;
  box-sizing: border-box;
  justify-content: ${props => props.theme.getJustifyContent(props.$alignment)};

  & button {
    height: 56px;
  }

  ${props =>
    props.$fullWidth || props.$fullWidthMobile
      ? stretchLinkAndButton
      : css`
          width: auto;
        `}

  @media ${props => props.theme.tablet} {
    ${props =>
      props.$fullWidth || props.$fullWidthDesktop
        ? stretchLinkAndButton
        : css`
            width: auto;

            & a {
              display: inline;
              width: auto;
            }

            & button {
              width: auto;
            }
          `}
  }
`;

export const CtaImageContainer = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  width: 20px;
  height: 20px;
  overflow: hidden;
  margin-right: ${props =>
    props.$position === 'left' ? props.theme.spacing(2) : '0'};
  margin-left: ${props =>
    props.$position === 'right' ? props.theme.spacing(2) : '0'};

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
